import { SyntheticEvent, FC } from "react";
import { Button, Space } from "antd";
import classNames from "classnames";
import { createUseStyles } from "react-jss";
import { blue } from "@ant-design/colors";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

interface ActionsProps {
  className?: string;
  onCancel: (event: SyntheticEvent<HTMLElement>) => void;
  onEditClick: (event: SyntheticEvent<HTMLElement>) => void;
  onDelete?: (event: SyntheticEvent<HTMLElement>) => void;
  deleting?: boolean;
  editing: boolean;
}

const useStyles = createUseStyles({
  button: {
    color: blue.primary,
  },
});

const Actions: FC<ActionsProps> = ({
  className,
  onEditClick,
  onCancel,
  onDelete,
  deleting,
  editing,
}) => {
  const classes = useStyles();

  return (
    <Space>
      {editing && (
        <Button
          type="text"
          htmlType="submit"
          className={classNames(classes.button, className)}
        >
          Save
        </Button>
      )}
      {!editing && (
        <Button
          type="text"
          htmlType="button"
          className={classNames(classes.button, className)}
          onClick={onEditClick}
        >
          <EditOutlined />
        </Button>
      )}
      {onDelete && !editing && (
        <Button
          danger
          type="text"
          htmlType="button"
          className={classNames(classes.button, className)}
          onClick={onDelete}
          loading={deleting}
          icon={<DeleteOutlined />}
        />
      )}
      {editing && (
        <Button
          type="text"
          htmlType="button"
          className={classNames(classes.button, className)}
          onClick={onCancel}
        >
          Cancel
        </Button>
      )}
    </Space>
  );
};

export default Actions;
